/* eslint-disable */
import BurgerMenu from '../plugins/burgerMenuPlugin';

export default function initPageHeader() {
    const NAV_HEIGHT_MAX = 140;
    const WIDE_HEADER_CLASS = 'header-too-wide';
    let navHeight = 0;
    let menuWidthBiggerThanWindow = false;

    const init = () => {
        const burgerMenu = new BurgerMenu(2400); // changed from 1200 to support wide header

        const header = document.querySelector('.header');
        if (header ) {
            /** listen for header height change  */
            const headerContent = header.querySelector('.header__content');
            const desktopNavContainer = header.querySelector('.main-nav-drop');

            const observer = new ResizeObserver(entries => {
                for (let entry of entries) {
                    const cr = entry.contentRect;
                    navHeight = cr.height;

                    if(navHeight > NAV_HEIGHT_MAX) {
                        header.classList.add(WIDE_HEADER_CLASS);
					}
                    /*header.querySelectorAll('*').forEach( el => {
                        if( !menuWidthBiggerThanWindow ) {
                            if (navHeight > NAV_HEIGHT_MAX ) {
                                el.classList.remove( WIDE_HEADER_CLASS );
                            } else {
                                el.classList.add( WIDE_HEADER_CLASS );
                            }
                        }
                    });*/
                }
            });
            observer.observe(headerContent);

            window.addEventListener('resize', onWindowResize);
            onWindowResize();
        }
    };

    const onWindowResize = () => {
        const header = document.querySelector('.header');
        header.classList.remove(WIDE_HEADER_CLASS);

        const desktopNavContainer = header.querySelector('.main-nav-drop');
        const navContainerFullWidth = desktopNavContainer.offsetWidth + desktopNavContainer.getBoundingClientRect().left;
        const windowWidth = window.innerWidth;

        menuWidthBiggerThanWindow = ( navContainerFullWidth > windowWidth);
        if(menuWidthBiggerThanWindow){
			header.classList.add(WIDE_HEADER_CLASS);
		}else{
			header.classList.remove(WIDE_HEADER_CLASS);
			if (document.body.API && document.body.API.isActive && window.innerWidth >= 1200) {
				//switching from mobile to desktop. close the mobile menu if opened
				document.body.API.hideMenu();
			}
		}
        /*document.querySelectorAll('.header *').forEach(el => {
            if (navHeight < NAV_HEIGHT_MAX) {
                (menuWidthBiggerThanWindow) ? el.classList.remove(WIDE_HEADER_CLASS) : el.classList.add(WIDE_HEADER_CLASS);
            }
        });*/
    };

    init();
}
